import { Box, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { LOAN_PATH } from '@/config/loanNavPaths';
import { LoanFlowChrome } from '@/components/Layout/Loan/LoanFlowChrome';
import { LoanFlowPageFrame } from '@/components/Layout/Loan/LoanFlowStatusBar';
import { InvestorProgramsPanel } from '@/components/Profile/InvestorProgramsPanel';
import { MortgageDocumentsWorkspace } from '@/components/Profile/MortgageDocumentsWorkspace';
import { ProfileAdvancedSettings } from '@/components/Profile/ProfileAdvancedSettings';
import { ProfileLoanStatus } from '@/components/Profile/ProfileLoanStatus';
import { ProfileLoanType } from '@/components/Profile/ProfileLoanType';
import { CommercialLoanApplicationPage } from '@/pages/App/CommercialLoanApplicationPage';
import { CommercialLoanHubPage } from '@/pages/App/CommercialLoanHubPage';

export function LoanHubRoute() {
  return (
    <LoanFlowChrome>
      <CommercialLoanHubPage />
    </LoanFlowChrome>
  );
}

/** Loan type: workflow (purchase / refinance / investor), program, and occupancy. */
export function LoanLoanTypeRoute() {
  const navigate = useNavigate();
  return (
    <LoanFlowChrome>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <LoanFlowPageFrame>
          <ProfileLoanType
            onContinueToQualifications={() =>
              navigate(LOAN_PATH.qualifications)
            }
          />
          <Box sx={{ mt: 3 }}>
            <InvestorProgramsPanel />
          </Box>
        </LoanFlowPageFrame>
      </Container>
    </LoanFlowChrome>
  );
}

/** Loan qualifications: income, credit, debt, and buying power. */
export function LoanQualificationsRoute() {
  return (
    <LoanFlowChrome>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <LoanFlowPageFrame>
          <ProfileAdvancedSettings />
        </LoanFlowPageFrame>
      </Container>
    </LoanFlowChrome>
  );
}

export function LoanStatusRoute() {
  return (
    <LoanFlowChrome>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <LoanFlowPageFrame>
          <ProfileLoanStatus />
        </LoanFlowPageFrame>
      </Container>
    </LoanFlowChrome>
  );
}

export function LoanDocumentsRoute() {
  return (
    <LoanFlowChrome>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <LoanFlowPageFrame>
          <MortgageDocumentsWorkspace variant="page" />
        </LoanFlowPageFrame>
      </Container>
    </LoanFlowChrome>
  );
}

export function LoanApplicationRoute() {
  return (
    <LoanFlowChrome>
      <CommercialLoanApplicationPage />
    </LoanFlowChrome>
  );
}
